import i18next from 'i18next';
import { streetTypesEnum } from 'constants/streetTypes';

export const streetTypesLiteralsManager = {
  [streetTypesEnum.ALLEYWAY]: () => i18next.t('alleyway'),
  [streetTypesEnum.AVENUE]: () => i18next.t('avenue'),
  [streetTypesEnum.PASSAGEWAY]: () => i18next.t('passageway'),
  [streetTypesEnum.RIDE]: () => i18next.t('ride'),
  [streetTypesEnum.ROAD]: () => i18next.t('road'),
  [streetTypesEnum.ROUND]: () => i18next.t('round'),
  [streetTypesEnum.SQUARE]: () => i18next.t('square'),
  [streetTypesEnum.STREET]: () => i18next.t('street'),
};
